"use client";

import { createStore, mergeStore, omit, setup, subscribe, sync, throwOnConflictingProps } from "./EQQLU3CG.js";
import { defaultValue } from "./PBFD2E7P.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/disclosure/disclosure-store.ts
function createDisclosureStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = mergeStore(props.store, omit(props.disclosure, ["contentElement", "disclosureElement"]));
  throwOnConflictingProps(props, store);
  var syncState = store == null ? void 0 : store.getState();
  var open = defaultValue(props.open, syncState == null ? void 0 : syncState.open, props.defaultOpen, false);
  var animated = defaultValue(props.animated, syncState == null ? void 0 : syncState.animated, false);
  var initialState = {
    open: open,
    animated: animated,
    animating: !!animated && open,
    mounted: open,
    contentElement: defaultValue(syncState == null ? void 0 : syncState.contentElement, null),
    disclosureElement: defaultValue(syncState == null ? void 0 : syncState.disclosureElement, null)
  };
  var disclosure = createStore(initialState, store);
  setup(disclosure, function () {
    return sync(disclosure, ["animated", "animating"], function (state) {
      if (state.animated) return;
      disclosure.setState("animating", false);
    });
  });
  setup(disclosure, function () {
    return subscribe(disclosure, ["open"], function () {
      if (!disclosure.getState().animated) return;
      disclosure.setState("animating", true);
    });
  });
  setup(disclosure, function () {
    return sync(disclosure, ["open", "animating"], function (state) {
      disclosure.setState("mounted", state.open || state.animating);
    });
  });
  return __spreadProps(__spreadValues({}, disclosure), {
    disclosure: props.disclosure,
    setOpen: function setOpen(value) {
      return disclosure.setState("open", value);
    },
    show: function show() {
      return disclosure.setState("open", true);
    },
    hide: function hide() {
      return disclosure.setState("open", false);
    },
    toggle: function toggle() {
      return disclosure.setState("open", function (open2) {
        return !open2;
      });
    },
    stopAnimation: function stopAnimation() {
      return disclosure.setState("animating", false);
    },
    setContentElement: function setContentElement(value) {
      return disclosure.setState("contentElement", value);
    },
    setDisclosureElement: function setDisclosureElement(value) {
      return disclosure.setState("disclosureElement", value);
    }
  });
}
export { createDisclosureStore };